<template>
  <SettingsPageLayout>
    <DetailForm
      v-if="loaded"
      title="Profile"
      description="Here you can edit profile information of your Company that are automatically syndicated to our job posting boards. Be sure to use your latest and greatest company logo etc."
      action="Save"
      hidecancel="true"
      @handle-action="updateTeam"
    >
      <TextInput
        label="Company Name"
        placeholder="Humaniz"
        :model-value="team.company"
        @update:model-value="value => (team.company = value)"
      />
      <TextInput
        label="Email Reply-To"
        placeholder="recruiting@brokerage.com"
        :model-value="team.replyTo"
        @update:model-value="value => (team.replyTo = value)"
      />
      <FileInput
        label="Company Logo"
        limits="any Image"
        :imageholder="team.companyLogo"
        :model-value="team.companyLogoFile"
        accept="image/*"
        @update:model-value="team.companyLogoFile = $event"
      />
    </DetailForm>
  </SettingsPageLayout>
</template>

<script>
import SettingsPageLayout from '../../layouts/SettingsPageLayout/index.vue';
import DetailForm from '../../shared/DetailForm.vue';
import { toast } from 'vue-sonner';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';

export default {
  components: {
    SettingsPageLayout,
    DetailForm,
  },
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      team: {
        id: '',
        company: '',
        replyTo: '',
        companyLogo: '',
        companyLogoFile: null,
      },
      loaded: false,
    };
  },
  mounted() {
    this.getTeam();
  },
  methods: {
    getTeam() {
      const self = this;
      this.loadingSpinnerStore.showLoadingSpinner();
      fetch('/api/team')
        .then(response => {
          this.loadingSpinnerStore.hideLoadingSpinner();
          return response.json();
        })
        .then(data => {
          self.team.id = data.record.id;
          self.team.company = data.record.company;
          self.team.replyTo = data.record.email_reply_to;
          self.team.companyLogo = data.record.logo;
          self.loaded = true;
        });
    },
    updateTeam() {
      const self = this;
      let formData = new FormData();
      formData.append('company', self.team.company);
      formData.append('email_reply_to', self.team.replyTo);
      self.team.companyLogoFile ? formData.append('company_logo', self.team.companyLogoFile) : null;
      this.loadingSpinnerStore.showLocalLoadingSpinner();
      fetch('/api/team', {
        method: 'PUT',
        body: formData,
        headers: {
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          this.loadingSpinnerStore.hideLocalLoadingSpinner();
          self.getTeam();
          if (data.status != 'error') {
            toast.success('Profile updated', {
              action: { label: 'Dismiss' },
              description:
                'Your company settings were successfully updated.  Use the button below to dismiss this alert.',
            });
          } else {
            toast.error('Profile update error', {
              action: { label: 'Dismiss' },
              description: data.message,
            });
          }
        });
    },
  },
};
</script>
